import React, { Component, createRef } from "react";
import { Layout, MTools, Player } from "@/components";
import BetterScroll from "@better-scroll/core";
import PullUp from "@better-scroll/pull-up";
import { RouteComponentProps, withRouter } from "dva/router";
import WonderfulActivities from "@/components/wonderfulActivities";
import { getActivityListDetail } from "@/services/service";
import styles from "./index.less";

interface CloudClassroomDetailProps {}
interface CloudClassroomDetailState {
  list: any;
  loading: boolean;
  hasMore: boolean;

  topicId: string | null;
}

type CloudClassroomDetailInfo = CloudClassroomDetailProps & RouteComponentProps;

BetterScroll.use(PullUp);

class CloudClassroomDetail extends Component<
  CloudClassroomDetailInfo,
  CloudClassroomDetailState
> {
  indexRef: any;
  bs: any;
  el: any;

  constructor(props: CloudClassroomDetailInfo) {
    super(props);
    this.state = {
      list: {},
      loading: false,
      hasMore: true,
      topicId: null,
    };
    this.indexRef = createRef();
    this.el = createRef();
  }

  componentDidMount() {
    this.getActivityListDetail();
  }

  // 获取视频详情
  getActivityListDetail = async () => {
    if (!this.state.hasMore) return;
    this.setState({
      loading: true,
    });

    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : null;
    const result = await getActivityListDetail(Id);
    if (result.success) {
      this.setState({
        list: result.data,
        topicId: result.data.topicId || null,
      });
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }

    this.setState({
      loading: false,
    });
  };

  getEL = (video: any) => {
    this.el.current = video;
  };

  render() {
    const { list } = this.state;
    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : null;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <Layout padding={23} share={true} businessType={2} businessId={Id}>
          {Object.keys(list).length > 0 && (
            <div className={styles.wrap}>
              <div className={styles.wrap_header}>
                <dl>
                  <dt>{list.title}</dt>
                  <dd>
                    <Player
                      getVideo={this.getEL}
                      poster={list.cover}
                      url={list.url}
                    />
                  </dd>
                </dl>
              </div>
              {/* 精彩活动 */}
              <WonderfulActivities />
            </div>
          )}
        </Layout>
      </div>
    );
  }
}

export default withRouter(CloudClassroomDetail);
